import api from '../../api';
import type { PayrollEmployeeDetail, PayrollEmployeeRow } from '../../../types/Payroll';

export async function fetchPayrollEmployees(): Promise<PayrollEmployeeRow[]> {
  const response = await api.get<{ employees?: PayrollEmployeeRow[] }>('/payroll/employees');
  return Array.isArray(response.data.employees) ? response.data.employees : [];
}

export async function fetchPayrollEmployeeById(employeeId: number): Promise<PayrollEmployeeDetail> {
  const response = await api.get<{ employee: PayrollEmployeeDetail }>(`/payroll/employees/${employeeId}`);
  return response.data.employee;
}

export type EmploymentTaxIncentiveResponse = {
  employee: {
    employeeId: number;
    employeeCode: string;
    firstName: string;
    surname: string;
  };
  eligibility: {
    age: string;
    yearsEmployed: string;
    grossSalary: string;
    etiClaim: string;
  };
};

export async function fetchPayrollEmploymentTaxIncentiveByEmployeeId(employeeId: number): Promise<EmploymentTaxIncentiveResponse> {
  const response = await api.get<EmploymentTaxIncentiveResponse>(`/payroll/employee-tax-incentive/${employeeId}`);
  return response.data;
}

export async function createPayrollRun(payCycleId: number, payDate?: string) {
  const response = await api.post('/payroll/runs', {
    pay_cycle_id: payCycleId,
    pay_date: payDate,
  });
  return response.data;
}

export async function generatePayslipsForPayrollRun(payrollRunId: number) {
  const response = await api.post('/payroll/runs/generate-payslips', {
    payroll_run_id: payrollRunId,
  });
  return response.data;
}

/** Last day of the previous month as dd/mm/yyyy (the payslip page's date format). */
export function lastDayOfPreviousMonth(now: Date = new Date()): string {
  return new Date(now.getFullYear(), now.getMonth(), 0).toLocaleDateString('en-GB');
}

export type PayslipPeriod = 'current' | 'previous';

export async function generatePayslipForEmployee(employeeId: number, period: PayslipPeriod = 'current') {
  const response = await api.post('/payroll/generate-payslip', {
    employee_id: employeeId,
    period,
  });
  return response.data;
}
